package com.shadowings.gero.data.lessons.chapter4

import androidx.compose.foundation.layout.Row
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_intro
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_known_title
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_known_words
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_missing_word
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_reveal_1
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_reveal_2
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_reveal_3
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_reveal_4
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_reveal_5
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_reveal_6
import gero.composeapp.generated.resources.exp_content_mysterious_cartouche_target
import gero.composeapp.generated.resources.lesson_mysterious_cartouche_title

fun getMysteriousCartoucheContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_intro,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_target,
            face = Faces.Serious,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("V28-D36:Q3-M17-G43B-S34", rtl = false, cart = true)
                }
            },
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_known_title,
            face = Faces.Happy,
            composable = {
                MdCWord("M23-L2", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_known_words,
            face = Faces.Happy,
            composable = {
                MdCWord("G43B-S34", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_missing_word,
            face = Faces.Surprised,
            composable = {
                MdCWord("V28-D36:Q3-M17", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_reveal_1,
            face = Faces.Surprised,
            composable = {
                MdCWord("V28-D36:Q3-M17", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_reveal_2,
            face = Faces.Perfect,
            composable = {
                MdCWord("V28-D36:Q3-M17", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_reveal_3,
            face = Faces.Serious,
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_reveal_4,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_reveal_5,
            face = Faces.Perfect,
        ),
        ExplanationContent(
            title = Res.string.lesson_mysterious_cartouche_title,
            content = Res.string.exp_content_mysterious_cartouche_reveal_6,
            face = Faces.Happy,
        )
    )
}
